var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cancel-root" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "contract-sty" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 19 } }, [
                _c(
                  "div",
                  { staticClass: "right-contract-box" },
                  [
                    _c("contract", {
                      attrs: {
                        INVALI: _vm.INVALI,
                        cancelForm: _vm.cancelForm,
                        reasonSet: _vm.reasonSet
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("el-col", { attrs: { span: 5 } }, [
                _c(
                  "div",
                  { staticClass: "left-input-box" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "cancelFormRef",
                        staticClass: "form-sty",
                        attrs: {
                          model: _vm.cancelForm,
                          rules: _vm.rules,
                          "label-position": "top",
                          size: "small"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "作废原因：", prop: "reason" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择作废原因" },
                                model: {
                                  value: _vm.cancelForm.reason,
                                  callback: function($$v) {
                                    _vm.$set(_vm.cancelForm, "reason", $$v)
                                  },
                                  expression: "cancelForm.reason"
                                }
                              },
                              _vm._l(_vm.reasonSet, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "详细说明：" } },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.cancelForm.reasontxt,
                                callback: function($$v) {
                                  _vm.$set(_vm.cancelForm, "reasontxt", $$v)
                                },
                                expression: "cancelForm.reasontxt"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "上传附件：" } },
                          [
                            _c(
                              "el-upload",
                              {
                                staticStyle: { "margin-bottom": "5px" },
                                attrs: {
                                  action: "#",
                                  multiple: "",
                                  "show-file-list": false,
                                  "file-list": _vm.enclosureFilesList,
                                  "before-upload":
                                    _vm.enclosureFilesBeforeUpload,
                                  limit: 30,
                                  "on-exceed": _vm.enclosureFilesHandleExceed,
                                  "on-error": _vm.enclosureFilesError
                                }
                              },
                              [
                                _c("el-button", {
                                  attrs: { icon: "el-icon-plus", size: "small" }
                                })
                              ],
                              1
                            ),
                            _vm._l(_vm.enclosureFilesList, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "enclosure-list-sty"
                                },
                                [
                                  _c(
                                    "el-tooltip",
                                    { attrs: { content: item.fileName } },
                                    [
                                      _c("p", { staticClass: "desc" }, [
                                        _vm._v(_vm._s(item.fileName))
                                      ])
                                    ]
                                  ),
                                  _c("span", {
                                    staticClass: "el-icon-error del-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.delEnclosureFiles(index)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            })
                          ],
                          2
                        ),
                        _vm.isInDingTalk || _vm.isCorp
                          ? _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  label: "审批流程：",
                                  prop: "approvalFlowSelect"
                                }
                              },
                              [
                                _vm.isInDingTalk
                                  ? [
                                      _c(
                                        "el-tabs",
                                        {
                                          attrs: { stretch: true },
                                          model: {
                                            value: _vm.flowType,
                                            callback: function($$v) {
                                              _vm.flowType = $$v
                                            },
                                            expression: "flowType"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-tab-pane",
                                            {
                                              staticStyle: { padding: "20px" },
                                              attrs: {
                                                label: "选择审批流程",
                                                name: _vm.flowTypes[0]
                                              }
                                            },
                                            [
                                              _c("flow-path", {
                                                on: {
                                                  flowSelectChange:
                                                    _vm.flowSelectChange
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-tab-pane",
                                            {
                                              staticStyle: { padding: "20px" },
                                              attrs: {
                                                label: "自主选择审批人",
                                                name: _vm.flowTypes[1]
                                              }
                                            },
                                            [
                                              _c("self-selection", {
                                                attrs: { menbers: _vm.menbers },
                                                on: {
                                                  chooseMenber:
                                                    _vm.chooseMenber,
                                                  delUser: _vm.delUser,
                                                  delLeven: _vm.delLeven,
                                                  addLeven: _vm.addLeven
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  : [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            size: "mini",
                                            placeholder: "请选择审批流程"
                                          },
                                          on: {
                                            change: _vm.handleChangeApprovalFlow
                                          },
                                          model: {
                                            value:
                                              _vm.cancelForm.approvalFlowSelect,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cancelForm,
                                                "approvalFlowSelect",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cancelForm.approvalFlowSelect"
                                          }
                                        },
                                        _vm._l(_vm.approvalFlowList, function(
                                          v,
                                          index
                                        ) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              value: v.flowId,
                                              label: v.flowName
                                            }
                                          })
                                        }),
                                        1
                                      ),
                                      _vm.flows.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                border:
                                                  "1px solid rgba(229, 229, 229, 1)",
                                                "border-radius": "4px",
                                                "margin-top": "12px",
                                                padding: "0 5px"
                                              }
                                            },
                                            _vm._l(_vm.flows, function(
                                              flow,
                                              i
                                            ) {
                                              return _c("span", { key: i }, [
                                                _vm._v(
                                                  _vm._s(flow.partyName) +
                                                    _vm._s(
                                                      i < _vm.flows.length - 1
                                                        ? flow.hiddenArrow
                                                          ? " ->"
                                                          : " 、"
                                                        : ""
                                                    )
                                                )
                                              ])
                                            }),
                                            0
                                          )
                                        : _vm._e()
                                    ]
                              ],
                              2
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          { attrs: { label: "意愿认证：", prop: "authLevel" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.cancelForm.authLevel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.cancelForm, "authLevel", $$v)
                                  },
                                  expression: "cancelForm.authLevel"
                                }
                              },
                              _vm._l(_vm.approvalSet, function(flow) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: flow.value,
                                    attrs: { label: flow.value }
                                  },
                                  [_vm._v(_vm._s(flow.label))]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-sty",
                        attrs: { type: "primary" },
                        on: { click: _vm.cancelComfirm }
                      },
                      [_vm._v("发起作废协议")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "prise-dialog",
          attrs: {
            visible: _vm.priseVisibleDialog,
            title: "温馨提示",
            "show-close": false,
            "close-on-click-modal": false,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.priseVisibleDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "box-dashed text-center",
              staticStyle: { "margin-top": "10px", "padding-bottom": "5px" }
            },
            [
              _c("img", {
                staticStyle: { height: "80px" },
                attrs: { src: "/images/icon_signed.png" }
              }),
              _vm.priseInfo.mealInfo
                ? [
                    _c("h4", [
                      _vm._v("\n          本次共花费：\n          "),
                      _c("span", { staticClass: "color-danger" }, [
                        _vm._v(_vm._s(_vm.priseInfo.mealInfo))
                      ])
                    ]),
                    _vm.priseInfo.point
                      ? _c("h4", [
                          _vm._v("\n          另需要支付\n          "),
                          _c("span", { staticClass: "color-danger" }, [
                            _vm._v(_vm._s(_vm.priseInfo.point) + "积分")
                          ])
                        ])
                      : _vm._e()
                  ]
                : _c("h4", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("\n        本次共花费：\n        "),
                    _c("span", { staticClass: "color-danger" }, [
                      _vm._v(_vm._s(_vm.priseInfo.point) + "积分")
                    ])
                  ]),
              _c(
                "p",
                {
                  staticStyle: { "text-align": "start", "margin-left": "8px" }
                },
                [
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(
                    "\n        发起后，签署方将收到签署短信通知，该通知72小时有效，请尽快完成签署！\n      "
                  )
                ]
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "text-center",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "footer-btn",
                  attrs: {
                    type: "danger",
                    size: "small",
                    disabled: _vm.payDisabled
                  },
                  on: {
                    click: function($event) {
                      return _vm.toPay()
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _c("span", { staticClass: "icon-sty" }),
      _vm._v("作废协议\n  ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4256ee7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4256ee7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initiation/invalidation/cancellation.vue
// module id = t+jE
// module chunks = 100